<template>
  <div>
    <div v-if="hasGetTheLooks">
      <ComponentLoader :loading="getGetTheLookLoading"/>
      <GetTheLookHeader :use-as-separate="useAsSeparate"/>
      <div v-for="(stylisationSet, stylisationIndex) in GetTheLooks" :key="stylisationSet.categoryNumber">
        <swiper
            class="swiper"
            :navigation="true"
            :modules="modules"
            :space-between="30"
            :slides-per-view="1"
            :centered-slides="false"
            :pagination="{ clickable: true }"
            @slideChange="event => updateActiveStylization(event,stylisationIndex)"
        >

          <swiper-slide class="slide" v-for="product in stylisationSet.products" :key="product.id">
            <div class="q-row q-px-5 q-mb-2 q-bg-white get-the-look__gtl-container">
              <GetTheLook :product="product" :use-as-separate="useAsSeparate"/>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div v-if="totalValue !== 0" class=" q-px-5 q-mb-2 q-bg-white get-the-looks__price-container q-d-flex">
        <span class="get-the-look__total-text">{{ 'Wartość wybranej stylizacji: ' }}</span>
        <div class="get-the-look__total-prices">
          <strong class="get-the-look__total-price " :class="{'--promotion': discount }">
            {{ formatPrice(totalValue) }}&nbsp;
          </strong>
          <del v-if="totalOldValue && totalValue !== totalOldValue" class="get-the-look__tot-price-old">
            {{ formatPrice(totalOldValue) }}
          </del>
        </div>
        <div v-if="discount && totalValue !== totalOldValue" class="stylisation__total-discount">
          <span class="stylisation__total-discount-text">Rabat:</span><span class="stylisation__discount">-{{discount}}%</span>
        </div>
      </div>
      <SeeMoreButton v-if="useAsSeparate" :title="'Zobacz inne stylizacje >'"/>
    </div>
    <NoStylisationInfo :show-alert="!getGetTheLookLoading && hasStylisation && !hasGetTheLooks"/>
  </div>

</template>
<script setup lang="ts">

import {onMounted, ref, defineProps, PropType, computed, watch} from 'vue'
import ComponentLoader from './ComponentLoader.vue'
import {Navigation, Pagination} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import GetTheLook from '@/components/GetTheLook/GetTheLook.vue'
import {storeToRefs} from 'pinia'
import {useGetTheLookStore} from '@/store/getTheLookStore'
import GetTheLookHeader from '@/components/GetTheLook/GetTheLookHeader.vue'
import SeeMoreButton from "@/components/SeeMoreButton.vue";
import {formatPrice, getDiscount, parsePrice} from "@/core/utils";
import {useStylisationStore} from "@/store/stylisationStore";

const props = defineProps({
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
});

const modules = ref([Pagination, Navigation])

const getTheLookStore = useGetTheLookStore()
const stylizationStore = useStylisationStore()
const {stylisationId} = storeToRefs(stylizationStore)

const {
  getTheLooksCategorized,
  getGetTheLooksWithoutFirst,
  getGetTheLookLoading,
  hasGetTheLooks
} = storeToRefs(getTheLookStore)

const GetTheLooks = computed(() => {
  return props.useAsSeparate ? getGetTheLooksWithoutFirst.value : getTheLooksCategorized.value
})

const stylisationStore = useStylisationStore()

const {hasStylisation} = storeToRefs(stylisationStore)

const totalValue = ref(0);
const totalOldValue = ref(0);
const activeProducts = ref([] as Array<object>)

const discount = ref<number | null>(0);


function updateActiveStylization(swiper, changedStylisation: number) {

  const activeProductIndex = swiper.activeIndex;
  const activeStylization = GetTheLooks.value[changedStylisation];

  activeProducts.value[changedStylisation] = activeStylization.products[activeProductIndex]
  calculateSumOfActiveProducts()
  calculateOldSumOfActiveProducts()
  calculateTotalDiscount()
}


const calculateSumOfActiveProducts = () => {

  totalValue.value = activeProducts.value.reduce((sum, product) => {

    if (!product || typeof product.variants === 'undefined') {
      return 0
    }
    const price = product.price
    const firstVariant = product.variants[0]
    const salePrice = firstVariant.sale_price || firstVariant.old_price

    const actualPrice = salePrice ? salePrice : price

    const priceNumber = parsePrice(actualPrice)?.toFixed(2)


    return (Number(sum) + Number(priceNumber)).toFixed(2);
  }, 0)
}

const calculateOldSumOfActiveProducts = () => {
  totalOldValue.value = activeProducts.value.reduce((sum, product) => {
    if (!product || typeof product.variants === 'undefined') {
      return 0
    }
    const price = product.price
    const firstVariant = product.variants[0]
    const salePrice = firstVariant.sale_price || firstVariant.old_price || product.price

    const oldPrice = salePrice ? price : salePrice

    const oldPriceNumber = parsePrice(oldPrice) || 0


    return (Number(sum) + Number(oldPriceNumber)).toFixed(2);
  }, 0)
}

const getInitialActiveProducts = () => {
  if (!hasGetTheLooks.value) {
    return
  }

  activeProducts.value = GetTheLooks?.value.map(element => {
    return element.products[0]
  })


}

const calculateTotalDiscount = () => {
  discount.value = getDiscount(totalValue.value, totalOldValue.value)
}


onMounted(async () => {
  await getTheLookStore.fetchGetTheLooksCategorized()
  getInitialActiveProducts()
  calculateSumOfActiveProducts()
  calculateOldSumOfActiveProducts()
  calculateTotalDiscount()
})
watch(stylisationId, () => {

  getInitialActiveProducts()
  calculateSumOfActiveProducts()
  calculateOldSumOfActiveProducts()
  calculateTotalDiscount()

}, {immediate: false});

</script>
<style>
.stylisation__total-discount {
  display: inline-block;
  background: red;
  color: #fff;
  font-size: 1rem;
  padding: 1px 8px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 0.25rem;
}

.get-the-look__total-price.--promotion {
  color: red;
  margin-left: 0.25rem;
}
</style>

